import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { logout } from '../services/sessionService';

export default function Navbar({ user }) {
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);
  const nombreUsuario =
    user?.nombre?.trim() ||
    user?.email?.split('@')[0] ||
    'Usuario';

  const handleLogout = async () => {
    await logout();
    navigate('/login', { replace: true });
  };

  if (!user) {
    return null;
  }

  return (
    <nav className="sticky top-0 z-50 border-b border-slate-800 bg-slate-950/95 text-white shadow-sm backdrop-blur">
      <div className="mx-auto w-full max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className="flex h-16 items-center justify-between">
          <div className="flex items-center gap-6">
            <Link
              to="/"
              className="flex items-center"
            >
              <img
                src="/logo-smartgage-dark.png"
                alt="SmartGage - Metrology Management"
                className="h-10 w-auto object-contain"
              />
            </Link>

            <ul className="hidden items-center gap-1 sm:flex">
              <li>
                <Link
                  to="/"
                  className="rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition hover:bg-slate-900 hover:text-cyan-300"
                >
                  Panel de Control
                </Link>
              </li>

              <li>
                <Link
                  to="/instrumentos"
                  className="rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition hover:bg-slate-900 hover:text-cyan-300"
                >
                  Instrumentos
                </Link>
              </li>

              <li>
                <Link
                  to="/calendario"
                  className="rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition hover:bg-slate-900 hover:text-cyan-300"
                >
                  Calendario
                </Link>
              </li>
            </ul>
          </div>

          <div className="flex items-center gap-3">
            <div className="hidden text-right md:block">
              <div className="text-sm font-medium text-slate-100">
                {nombreUsuario}
              </div>

              <div className="max-w-48 truncate text-xs text-slate-400">
                {user.empresa_nombre || 'Sin empresa'}
              </div>
            </div>

            <button
              className="inline-flex items-center justify-center rounded-lg p-2 text-slate-300 transition hover:bg-slate-900 hover:text-white sm:hidden"
              aria-label="Abrir menú"
              aria-expanded={open}
              onClick={() => setOpen((v) => !v)}
            >
              <div>
                <span className="mb-1 block h-0.5 w-5 bg-current" />
                <span className="mb-1 block h-0.5 w-5 bg-current" />
                <span className="block h-0.5 w-5 bg-current" />
              </div>
            </button>

            <button
              onClick={handleLogout}
              className="hidden rounded-lg border border-slate-700 px-3 py-2 text-sm font-medium text-slate-300 transition hover:border-red-500/60 hover:bg-red-950/30 hover:text-red-300 sm:block"
            >
              Cerrar sesión
            </button>
          </div>
        </div>

        <div className={`${open ? 'block' : 'hidden'} border-t border-slate-800 pb-3 sm:hidden`}>
          <ul className="space-y-1 pt-3">
            <li>
              <Link
                to="/"
                className="block rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition hover:bg-slate-900 hover:text-cyan-300"
                onClick={() => setOpen(false)}
              >
                Panel de Control
              </Link>
            </li>

            <li>
              <Link
                to="/instrumentos"
                className="block rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition hover:bg-slate-900 hover:text-cyan-300"
                onClick={() => setOpen(false)}
              >
                Instrumentos
              </Link>
            </li>

            <li>
              <Link
                to="/calendario"
                className="block rounded-lg px-3 py-2 text-sm font-medium text-slate-300 transition hover:bg-slate-900 hover:text-cyan-300"
                onClick={() => setOpen(false)}
              >
                Calendario
              </Link>
            </li>

            <li className="mt-3 border-t border-slate-800 pt-3">
              <div className="px-3 pb-3">
                <div className="text-sm font-medium text-white">
                  {nombreUsuario}
                </div>
                <div className="truncate text-xs text-slate-400">
                  {user.empresa_nombre || 'Sin empresa'}
                </div>
              </div>

              <button
                onClick={handleLogout}
                className="w-full rounded-lg border border-slate-700 px-3 py-2 text-left text-sm font-medium text-slate-300 transition hover:border-red-500/60 hover:bg-red-950/30 hover:text-red-300"
              >
                Cerrar sesión
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
}